import { authProvider as loopbackAuthClient } from '../lib/react-admin-loopback';

export const authProvider = loopbackAuthClient(
	`${process.env.REACT_APP_API_URL}/webUsers/login`
);